function Nav() {
    return (
        <ul className="flex font-bold hidden md:flex">
            {/*<li className="px-3 hover:text-cta-500 hover:underline"><a href="/">Home</a></li>*/}
            {/*<li className="pl-3 hover:text-cta-500 hover:underline"><a href="#contact-us">Contact Us</a></li>*/}
        </ul>
    );
}

export default Nav;